webpackJsonp([1],{

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(102);



/* unused harmony default export */ var _unused_webpack_default_export = ({
  request: function request(method, uri) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (!method) {
      console.error('API function call requires method argument');
      return;
    }

    if (!uri) {
      console.error('API function call requires uri argument');
      return;
    }

    var url = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + uri;
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({ method: method, url: url, data: data });
  }
});

/***/ }),

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false
});

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 108:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "globalStore", function() { return globalStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filters__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_App_vue__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_App_vue__);















__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('count', __WEBPACK_IMPORTED_MODULE_7__filters__["a" /* count */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('domain', __WEBPACK_IMPORTED_MODULE_7__filters__["b" /* domain */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('prettyDate', __WEBPACK_IMPORTED_MODULE_7__filters__["c" /* prettyDate */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('pluralize', __WEBPACK_IMPORTED_MODULE_7__filters__["d" /* pluralize */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_3_moment___default()(String(value)).format('DD-MMM-YYYY | hh:mm:ss A');
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('Birthdate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_3_moment___default()(String(value)).format('DD-MMM-YYYY');
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('assignedOn', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_3_moment___default()(String(value)).format('DD MMM YYYY | hh:mm:ss A');
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('formatTime', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_3_moment___default()(String(value)).format('hh:mm:ss A');
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('formatSlot', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_3_moment___default()(String(value)).format('LT');
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_5__routes__["a" /* default */],

  linkExactActiveClass: 'active',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  }) && (!router.app.$store.state.token || router.app.$store.state.token === 'null')) {
    window.console.log('Not authenticated');
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */], router);

if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null';
  var localUser = JSON.parse(localUserString);

  if (localUser && __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.user !== localUser) {
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('SET_USER', localUser);
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('SET_TOKEN', window.localStorage.getItem('token'));
  }
}

var globalStore = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  data: {
    url: 'https://us-central1-visityio-24cf9.cloudfunctions.net/widgets',
    clientId: localStorage.getItem('clientId'),
    eventId: localStorage.getItem('eventId'),
    eventInfo: {}
  }
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#root',
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_8__components_App_vue___default.a);
  }
});

/***/ }),

/***/ 1440:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 152,
	"./af.js": 152,
	"./ar": 159,
	"./ar-dz": 153,
	"./ar-dz.js": 153,
	"./ar-kw": 154,
	"./ar-kw.js": 154,
	"./ar-ly": 155,
	"./ar-ly.js": 155,
	"./ar-ma": 156,
	"./ar-ma.js": 156,
	"./ar-sa": 157,
	"./ar-sa.js": 157,
	"./ar-tn": 158,
	"./ar-tn.js": 158,
	"./ar.js": 159,
	"./az": 160,
	"./az.js": 160,
	"./be": 161,
	"./be.js": 161,
	"./bg": 162,
	"./bg.js": 162,
	"./bm": 163,
	"./bm.js": 163,
	"./bn": 165,
	"./bn-bd": 164,
	"./bn-bd.js": 164,
	"./bn.js": 165,
	"./bo": 166,
	"./bo.js": 166,
	"./br": 167,
	"./br.js": 167,
	"./bs": 168,
	"./bs.js": 168,
	"./ca": 169,
	"./ca.js": 169,
	"./cs": 170,
	"./cs.js": 170,
	"./cv": 171,
	"./cv.js": 171,
	"./cy": 172,
	"./cy.js": 172,
	"./da": 173,
	"./da.js": 173,
	"./de": 176,
	"./de-at": 174,
	"./de-at.js": 174,
	"./de-ch": 175,
	"./de-ch.js": 175,
	"./de.js": 176,
	"./dv": 177,
	"./dv.js": 177,
	"./el": 178,
	"./el.js": 178,
	"./en-au": 179,
	"./en-au.js": 179,
	"./en-ca": 180,
	"./en-ca.js": 180,
	"./en-gb": 181,
	"./en-gb.js": 181,
	"./en-ie": 182,
	"./en-ie.js": 182,
	"./en-il": 183,
	"./en-il.js": 183,
	"./en-in": 184,
	"./en-in.js": 184,
	"./en-nz": 185,
	"./en-nz.js": 185,
	"./en-sg": 186,
	"./en-sg.js": 186,
	"./eo": 187,
	"./eo.js": 187,
	"./es": 191,
	"./es-do": 188,
	"./es-do.js": 188,
	"./es-mx": 189,
	"./es-mx.js": 189,
	"./es-us": 190,
	"./es-us.js": 190,
	"./es.js": 191,
	"./et": 192,
	"./et.js": 192,
	"./eu": 193,
	"./eu.js": 193,
	"./fa": 194,
	"./fa.js": 194,
	"./fi": 195,
	"./fi.js": 195,
	"./fil": 196,
	"./fil.js": 196,
	"./fo": 197,
	"./fo.js": 197,
	"./fr": 200,
	"./fr-ca": 198,
	"./fr-ca.js": 198,
	"./fr-ch": 199,
	"./fr-ch.js": 199,
	"./fr.js": 200,
	"./fy": 201,
	"./fy.js": 201,
	"./ga": 202,
	"./ga.js": 202,
	"./gd": 203,
	"./gd.js": 203,
	"./gl": 204,
	"./gl.js": 204,
	"./gom-deva": 205,
	"./gom-deva.js": 205,
	"./gom-latn": 206,
	"./gom-latn.js": 206,
	"./gu": 207,
	"./gu.js": 207,
	"./he": 208,
	"./he.js": 208,
	"./hi": 209,
	"./hi.js": 209,
	"./hr": 210,
	"./hr.js": 210,
	"./hu": 211,
	"./hu.js": 211,
	"./hy-am": 212,
	"./hy-am.js": 212,
	"./id": 213,
	"./id.js": 213,
	"./is": 214,
	"./is.js": 214,
	"./it": 216,
	"./it-ch": 215,
	"./it-ch.js": 215,
	"./it.js": 216,
	"./ja": 217,
	"./ja.js": 217,
	"./jv": 218,
	"./jv.js": 218,
	"./ka": 219,
	"./ka.js": 219,
	"./kk": 220,
	"./kk.js": 220,
	"./km": 221,
	"./km.js": 221,
	"./kn": 222,
	"./kn.js": 222,
	"./ko": 223,
	"./ko.js": 223,
	"./ku": 224,
	"./ku.js": 224,
	"./ky": 225,
	"./ky.js": 225,
	"./lb": 226,
	"./lb.js": 226,
	"./lo": 227,
	"./lo.js": 227,
	"./lt": 228,
	"./lt.js": 228,
	"./lv": 229,
	"./lv.js": 229,
	"./me": 230,
	"./me.js": 230,
	"./mi": 231,
	"./mi.js": 231,
	"./mk": 232,
	"./mk.js": 232,
	"./ml": 233,
	"./ml.js": 233,
	"./mn": 234,
	"./mn.js": 234,
	"./mr": 235,
	"./mr.js": 235,
	"./ms": 237,
	"./ms-my": 236,
	"./ms-my.js": 236,
	"./ms.js": 237,
	"./mt": 238,
	"./mt.js": 238,
	"./my": 239,
	"./my.js": 239,
	"./nb": 240,
	"./nb.js": 240,
	"./ne": 241,
	"./ne.js": 241,
	"./nl": 243,
	"./nl-be": 242,
	"./nl-be.js": 242,
	"./nl.js": 243,
	"./nn": 244,
	"./nn.js": 244,
	"./oc-lnc": 245,
	"./oc-lnc.js": 245,
	"./pa-in": 246,
	"./pa-in.js": 246,
	"./pl": 247,
	"./pl.js": 247,
	"./pt": 249,
	"./pt-br": 248,
	"./pt-br.js": 248,
	"./pt.js": 249,
	"./ro": 250,
	"./ro.js": 250,
	"./ru": 251,
	"./ru.js": 251,
	"./sd": 252,
	"./sd.js": 252,
	"./se": 253,
	"./se.js": 253,
	"./si": 254,
	"./si.js": 254,
	"./sk": 255,
	"./sk.js": 255,
	"./sl": 256,
	"./sl.js": 256,
	"./sq": 257,
	"./sq.js": 257,
	"./sr": 259,
	"./sr-cyrl": 258,
	"./sr-cyrl.js": 258,
	"./sr.js": 259,
	"./ss": 260,
	"./ss.js": 260,
	"./sv": 261,
	"./sv.js": 261,
	"./sw": 262,
	"./sw.js": 262,
	"./ta": 263,
	"./ta.js": 263,
	"./te": 264,
	"./te.js": 264,
	"./tet": 265,
	"./tet.js": 265,
	"./tg": 266,
	"./tg.js": 266,
	"./th": 267,
	"./th.js": 267,
	"./tk": 268,
	"./tk.js": 268,
	"./tl-ph": 269,
	"./tl-ph.js": 269,
	"./tlh": 270,
	"./tlh.js": 270,
	"./tr": 271,
	"./tr.js": 271,
	"./tzl": 272,
	"./tzl.js": 272,
	"./tzm": 274,
	"./tzm-latn": 273,
	"./tzm-latn.js": 273,
	"./tzm.js": 274,
	"./ug-cn": 275,
	"./ug-cn.js": 275,
	"./uk": 276,
	"./uk.js": 276,
	"./ur": 277,
	"./ur.js": 277,
	"./uz": 279,
	"./uz-latn": 278,
	"./uz-latn.js": 278,
	"./uz.js": 279,
	"./vi": 280,
	"./vi.js": 280,
	"./x-pseudo": 281,
	"./x-pseudo.js": 281,
	"./yo": 282,
	"./yo.js": 282,
	"./zh-cn": 283,
	"./zh-cn.js": 283,
	"./zh-hk": 284,
	"./zh-hk.js": 284,
	"./zh-mo": 285,
	"./zh-mo.js": 285,
	"./zh-tw": 286,
	"./zh-tw.js": 286
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1440;

/***/ }),

/***/ 1443:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 1464:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(421)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(1484),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1465:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(419)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(1482),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1466:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(418)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(1481),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1467:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(420)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(1483),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1468:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(416)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(1479),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1469:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(417)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(1480),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1470:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(423)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(1486),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1471:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(426)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(1489),
  /* scopeId */
  "data-v-80d36dd4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1472:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(429)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(1492),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1473:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(428)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(1491),
  /* scopeId */
  "data-v-b6d525ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1474:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(415)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(1478),
  /* scopeId */
  "data-v-1ca995c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1475:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(427)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(1490),
  /* scopeId */
  "data-v-a0b3cbe2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1476:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(424)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(1487),
  /* scopeId */
  "data-v-6ab82bbd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1477:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(422)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(1485),
  /* scopeId */
  "data-v-4de35fdf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1478:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.showLoading) ? _c('div', {
    staticClass: "row loadingContainer"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-5x fa-fw loading"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('br'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPleaseWait) ? _c('div', {
    staticClass: "row loadingContainer"
  }, [_c('h1', [_vm._v(_vm._s(_vm.alertMessage))])]) : _vm._e()])], 1), _vm._v(" "), (_vm.showTable) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row box-body"
  }, [_c('div', {
    staticClass: "col-sm-6 table-responsive",
    attrs: {
      "id": "Feedbacks"
    }
  }, [_c('table', {
    staticClass: "display table table-bordered table-striped dataTable wrap",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Selfie Clicked")]), _vm._v(" "), _c('td', {
    staticClass: "sorting_1"
  }, [(_vm.idCardInfo.customFields.idCardInfo.imageUrl) ? _c('p', [_vm._v("Yes")]) : _vm._e(), _vm._v(" "), (_vm.idCardInfo.customFields.idCardInfo.imageUrl == '') ? _c('p', [_vm._v("No")]) : _vm._e()])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("UID")]), _vm._v(" "), _c('td', {
    staticClass: "sorting_1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idCardInfo.customFields.rsvpInfo.uid),
      expression: "idCardInfo.customFields.rsvpInfo.uid"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "disabled": "true",
      "id": "exampleFormControlInput1",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.idCardInfo.customFields.rsvpInfo.uid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.idCardInfo.customFields.rsvpInfo, "uid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Name")]), _vm._v(" "), _c('td', {
    staticClass: "sorting_1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idCardInfo.customFields.rsvpInfo.name),
      expression: "idCardInfo.customFields.rsvpInfo.name"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "id": "exampleFormControlInput1",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.idCardInfo.customFields.rsvpInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.idCardInfo.customFields.rsvpInfo, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('td', {
    staticClass: "sorting_1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idCardInfo.customFields.rsvpInfo.mobile),
      expression: "idCardInfo.customFields.rsvpInfo.mobile"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "id": "exampleFormControlInput1",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.idCardInfo.customFields.rsvpInfo.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.idCardInfo.customFields.rsvpInfo, "mobile", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Email")]), _vm._v(" "), _c('td', {
    staticClass: "sorting_1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idCardInfo.customFields.rsvpInfo.email),
      expression: "idCardInfo.customFields.rsvpInfo.email"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "id": "exampleFormControlInput1",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.idCardInfo.customFields.rsvpInfo.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.idCardInfo.customFields.rsvpInfo, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("DOB")]), _vm._v(" "), _c('td', {
    staticClass: "sorting_1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idCardInfo.customFields.rsvpInfo.dob),
      expression: "idCardInfo.customFields.rsvpInfo.dob"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "id": "exampleFormControlInput1",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.idCardInfo.customFields.rsvpInfo.dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.idCardInfo.customFields.rsvpInfo, "dob", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.generateIdCard()
      }
    }
  }, [_vm._v("Generate ID Card")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sendIDCardPrompt()
      }
    }
  }, [_vm._v("Send ID Card")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    attrs: {
      "id": "Feedbacks"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "src": _vm.idCardInfo.customFields.idCardInfo.idCardUrl
    }
  })])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1479:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/registrations"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Registrations")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/checkpoints"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-qrcode",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("QR Code Scanner")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/history"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Scanner History")])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1480:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 item-right"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png",
      "id": "brand-logo"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Sign Up")]), _vm._v(" "), _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    attrs: {
      "type": "submit",
      "disabled": !_vm.isValidEmail
    }
  }, [_vm._v("LOGIN")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPleaseWait == true) ? _c('p', [_vm._v("Please wait...")]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showMessage == true) ? _c('h5', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.displayMsg) + "\n          ")]) : _vm._e()])], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1481:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 item-right"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png",
      "id": "brand-logo"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Admin Login")]), _vm._v(" "), _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    attrs: {
      "type": "submit",
      "disabled": !_vm.isValidEmail
    }
  }, [_vm._v("LOGIN")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPleaseWait == true) ? _c('p', [_vm._v("Please wait...")]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showMessage == true) ? _c('h5', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.displayMsg) + "\n          ")]) : _vm._e()])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 item-left"
  }, [_c('div', {
    attrs: {
      "id": "Logo"
    }
  })])
}]}

/***/ }),

/***/ 1482:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header"
  }, [_c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown user user-menu",
    on: {
      "click": function($event) {
        return _vm.Logout()
      }
    }
  }, [_vm._m(1)])])])])]), _vm._v(" "), _c('sidebar', {
    attrs: {
      "display-name": _vm.demo.displayName,
      "picture-url": _vm.demo.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.name.toUpperCase()) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.name.toUpperCase()))])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "main-footer"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v("   \n        "), _c('img', {
    attrs: {
      "src": "/static/img/logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "hidden-xs fa fa-power-off"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Home")])])
}]}

/***/ }),

/***/ 1483:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('sidebar-menu')], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1484:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notFound"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('h1', [_vm._v("You are lost.")]), _vm._v(" "), _c('h4', [_vm._v("This page doesn't exist.")]), _vm._v(" "), _c('router-link', {
    staticClass: "vertical-5p lead",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Take me home.")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1485:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "dash"
  }, [_c('h3', [_vm._v(_vm._s(_vm.Total))]), _vm._v(" "), _c('p', [_vm._v("Registrations")])]), _vm._v(" "), _c('div', {
    staticClass: "dash"
  }, [_c('h3', [_vm._v(_vm._s(_vm.Total - _vm.Arrived))]), _vm._v(" "), _c('p', [_vm._v("Not Arrived")])]), _vm._v(" "), _c('div', {
    staticClass: "dash"
  }, [_c('h3', [_vm._v(_vm._s(_vm.Arrived))]), _vm._v(" "), _c('p', [_vm._v("Arrived")])])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', [_vm._v("Category Wise Total")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.stats), function(S) {
    return [_c('tr', [_c('td', [_vm._v(_vm._s(S._id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(S.arrived))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(S.notArrived))])])]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('br'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPleaseWait) ? _c('div', {
    staticClass: "row loadingContainer"
  }, [_c('h1', [_vm._v(_vm._s(_vm.alertMessage))])]) : _vm._e()])], 1), _vm._v(" "), (_vm.showLoading) ? _c('div', {
    staticClass: "row loadingContainer"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-5x fa-fw loading"
  })]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.showTable) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row box-body"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "Feedbacks"
    }
  }, [_c('table', {
    staticClass: "display table table-bordered table-striped dataTable wrap",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("New UID")]), _vm._v(" "), _c('th', [_vm._v("On The Spot")]), _vm._v(" "), _c('th', [_vm._v("Selfie")]), _vm._v(" "), _vm._l((_vm.tableHeader.customFields.formFields), function(x) {
    return [_c('th', [_vm._v(_vm._s(_vm.capitalizeFirstLetter(x.label)))])]
  }), _vm._v(" "), _c('th', [_vm._v("QR Code")]), _vm._v(" "), _c('th', [_vm._v("ID Card")]), _vm._v(" "), _c('th', [_vm._v("Send Whatsapp")]), _vm._v(" "), _c('th', [_vm._v("Send Gen ID Card Link")]), _vm._v(" "), _c('th', [_vm._v("Current Status")]), _vm._v(" "), _c('th')], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.List), function(S, index) {
    return [_c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(" " + _vm._s(S.customFields.newUid) + " ")]), _vm._v(" "), _c('td', [( false) ? _c('p', [_vm._v("Yes")]) : _vm._e(), _vm._v(" "), ( true) ? _c('p', [_vm._v("No")]) : _vm._e()]), _vm._v(" "), _c('td'), _vm._v(" "), _vm._l((S.customFields.rsvpInfo), function(value, key) {
      return [_c('td', [(typeof value === 'string' && value.includes('https://firebasestorage')) ? [_c('a', {
        attrs: {
          "href": value,
          "target": "_blank"
        }
      }, [_vm._v("View")])] : [_vm._v("\n                                " + _vm._s(value) + "\n                              ")]], 2)]
    }), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_c('a', {
      attrs: {
        "href": S.eTicketUrl,
        "target": "_blank"
      }
    }, [_vm._v("View")])]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_c('button', {
      staticClass: "btn btn-outline-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.sendWhatsappPrompt(S);
        }
      }
    }, [_vm._v("\n                        Send Whatsapp\n                    ")])]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_c('button', {
      staticClass: "btn btn-outline-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.sendIDCardPrompt(S);
        }
      }
    }, [_vm._v("\n                        Send Link\n                    ")])]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1 text-center"
    }, [(S.status == '') ? _c('p', {
      attrs: {
        "id": "labelNotArrived"
      }
    }, [_vm._v("Not Arrived")]) : _vm._e(), _vm._v(" "), (S.status != '') ? _c('p', {
      attrs: {
        "id": "labelGreen"
      }
    }, [_vm._v(" " + _vm._s(_vm.capitalizeFirstLetter(S.status)) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editIDCard(S);
        }
      }
    }, [_vm._v("\n                        Edit\n                    ")])])], 2)]
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "modal-body"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.editInfo), function(value, key) {
    return _c('div', {
      key: key,
      staticClass: "form-group"
    }, [_c('label', {
      attrs: {
        "for": key
      }
    }, [_vm._v(_vm._s(_vm.capitalizeFirstLetter(key)))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editInfo[key]),
        expression: "editInfo[key]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": key,
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.editInfo[key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.editInfo, key, $event.target.value)
        }
      }
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.editSave()
      }
    }
  }, [_vm._v("Save & Generate ID Card")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showLoading2) ? _c('p', [_vm._v("Please wait...")]) : _vm._e()])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Arrived")]), _vm._v(" "), _c('th', [_vm._v("Not Arrived")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalCenterTitle"
    }
  }, [_vm._v("Edit ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Important:")]), _c('br'), _vm._v("\n              Photo, UID, Name, Mobile, Email & DOB will be displayed on the ID Card.\n            ")])
}]}

/***/ }),

/***/ 1486:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.showLoading) ? _c('div', {
    staticClass: "loadingContainer"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw loading"
  })]) : _vm._e(), _vm._v(" "), (_vm.showTable) ? _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row box-body"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "Feedbacks"
    }
  }, [_c('table', {
    staticClass: "display table table-bordered table-striped dataTable wrap",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.List), function(S, index) {
    return _c('tr', {
      staticClass: "even",
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.rsvpId.customFields.rsvpInfo.name))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.rsvpId.customFields.rsvpInfo.mobile))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(" " + _vm._s(_vm.capitalizeFirstLetter(S.checkpoint)) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(" " + _vm._s(_vm.capitalizeFirstLetter(S.rsvpId.customFields.rsvpInfo.category)) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(S.date)))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.checkpointId.name))])])
  }), 0)])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Mobile")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Checkpoint")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Category")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Timestamp")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Scanned By")])])])
}]}

/***/ }),

/***/ 1487:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-container"
  }, [_c('canvas', {
    ref: "canvas"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 1488:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1489:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('canvas', {
    ref: "chart"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 1490:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('canvas', {
    ref: "chart"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 1491:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('h4'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "dash"
  }, [_c('h3', [_vm._v(_vm._s(_vm.total))]), _vm._v(" "), _c('p', [_vm._v("Registrations")])]), _vm._v(" "), _vm._l((_vm.analytics), function(x) {
    return _c('div', {
      staticClass: "dash"
    }, [_c('h3', [_vm._v(_vm._s(x.count))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.capitalizeFirstLetter(x.checkpoint)))])])
  })], 2), _vm._v(" "), _c('hr')])
},staticRenderFns: []}

/***/ }),

/***/ 1492:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('p', [_vm._v("URL for QR Code Scanner Login is "), _c('a', {
    attrs: {
      "href": "https://scanner.visity.io/",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.scannerUrl))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-primary button",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#exampleModalCenter"
    }
  }, [_vm._v("\n          Add Checkpoint\n        ")])]), _vm._v(" "), (_vm.ShowLoading) ? _c('div', {
    staticClass: "loadingContainer"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw loading"
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowTable) ? _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row box-body"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "Feedbacks"
    }
  }, [_c('table', {
    staticClass: "display table table-bordered table-striped dataTable wrap",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.List), function(S, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.name))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.mobile))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.password))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(_vm.capitalizeFirstLetter(S.checkPoint)) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(S.createdOn)))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group mr-3",
      attrs: {
        "role": "group",
        "aria-label": "Second group"
      }
    }, [_c('button', {
      staticClass: "btn btn-warning",
      attrs: {
        "type": "submit",
        "data-toggle": "modal",
        "data-target": "#EditModal"
      },
      on: {
        "click": function($event) {
          return _vm.EditModal(S);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group mr-3",
      attrs: {
        "role": "group",
        "aria-label": "Second group"
      }
    }, [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          return _vm.Delete(S);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])
  }), 0)])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exampleModalCenter",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.Add()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Name *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "exampleFormControlInput1",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Mobile (for login) *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "exampleFormControlInput1",
      "minlength": "10",
      "maxlength": "10",
      "placeholder": "10 Digit Mobile Number",
      "required": ""
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Password *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "exampleFormControlInput1",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Checkpoint *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkpoint),
      expression: "checkpoint"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "exampleFormControlInput1",
      "required": ""
    },
    domProps: {
      "value": (_vm.checkpoint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkpoint = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "EditModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.Edit()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Person Name *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.EditInfo.name),
      expression: "EditInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "exampleFormControlInput1",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.EditInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.EditInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Mobile *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.EditInfo.mobile),
      expression: "EditInfo.mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "exampleFormControlInput1",
      "minlength": "10",
      "maxlength": "10",
      "placeholder": "10 Digit Mobile Number",
      "required": ""
    },
    domProps: {
      "value": (_vm.EditInfo.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.EditInfo, "mobile", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Password *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.EditInfo.password),
      expression: "EditInfo.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "exampleFormControlInput1",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.EditInfo.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.EditInfo, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Checkpoint *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.EditInfo.checkPoint),
      expression: "EditInfo.checkPoint"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "exampleFormControlInput1",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.EditInfo.checkPoint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.EditInfo, "checkPoint", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(4)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th'), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Mobile (for login)")]), _vm._v(" "), _c('th', [_vm._v("Password")]), _vm._v(" "), _c('th', [_vm._v("Checkpoint")]), _vm._v(" "), _c('th', [_vm._v("Created On")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalCenterTitle"
    }
  }, [_vm._v("Add Checkpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h3', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalCenterTitle"
    }
  }, [_vm._v("Edit Checkpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])
}]}

/***/ }),

/***/ 1494:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1495:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1496:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1497:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1498:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1499:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1500:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1501:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1502:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1503:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1504:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1505:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1506:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1507:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = domain;
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony export (immutable) */ __webpack_exports__["c"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = pluralize;
var urlParser = document.createElement('a');

function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

function count(arr) {
  return arr.length;
}

function prettyDate(date) {
  var a = new Date(date);
  return a.toDateString();
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }

  return time + label + 's';
}

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Signup_vue__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Signup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Signup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_404_vue__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_EditIDCard__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_EditIDCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_views_EditIDCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Registrations_vue__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Registrations_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_views_Registrations_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Checkpoints_vue__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Checkpoints_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_views_Checkpoints_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_AccessLogs_vue__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_AccessLogs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_views_AccessLogs_vue__);











var routes = [{
  path: '/signup',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Signup_vue___default.a
}, {
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default.a
}, {
  path: '/edit-id-card',
  alias: '',
  component: __WEBPACK_IMPORTED_MODULE_5__components_views_EditIDCard___default.a,
  name: 'Edit ID Card',
  meta: { description: '' }
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default.a,
  children: [{
    path: 'registrations',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_6__components_views_Registrations_vue___default.a,
    name: 'Registrations',
    meta: { description: '' }
  }, {
    path: 'checkpoints',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_7__components_views_Checkpoints_vue___default.a,
    name: 'QR Code Scanner',
    meta: { description: '' }
  }, {
    path: 'history',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_8__components_views_AccessLogs_vue___default.a,
    name: 'Scanner History',
    meta: { description: '' }
  }, {
    path: 'dashboard',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue___default.a,
    name: 'Dashboard',
    meta: { description: '' }
  }]
}, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_3__components_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(348);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
}));

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(425)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(1488),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound'
});

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  data: function data() {
    return {
      section: 'Head'
    };
  },

  methods: {
    logout: function logout() {
      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_TOKEN', null);

      if (window.localStorage) {
        window.localStorage.setItem('user', null);
        window.localStorage.setItem('token', null);
      }

      this.$router.push('/login');
    }
  }
});

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_faker__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_faker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_faker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hideseek__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hideseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hideseek__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main_js__ = __webpack_require__(13);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dash',
  components: {
    Sidebar: __WEBPACK_IMPORTED_MODULE_4__Sidebar___default.a
  },
  data: function data() {
    return {
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].fixedLayout,
        hide_logo: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].hideLogoOnMobile
      },
      error: ''
    };
  },
  mounted: function mounted() {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['userInfo']), {
    demo: function demo() {
      return {
        displayName: __WEBPACK_IMPORTED_MODULE_1_faker___default.a.name.findName(),
        avatar: __WEBPACK_IMPORTED_MODULE_1_faker___default.a.image.avatar(),
        email: __WEBPACK_IMPORTED_MODULE_1_faker___default.a.internet.email(),
        randomCard: __WEBPACK_IMPORTED_MODULE_1_faker___default.a.helpers.createCard()
      };
    }
  }),
  methods: {
    CheckLogin: function CheckLogin() {
      if (localStorage.getItem('clientId') && localStorage.getItem('eventId')) {
        console.log("Already Logged In");
        console.log("eventId: " + localStorage.getItem('eventId'));
        console.log("clientId: " + localStorage.getItem('clientId'));
      } else {
        console.log("Not Logged In");
        this.$router.push('/login');
      }
    },
    Logout: function Logout() {
      console.log("Log Out Clicked");
      localStorage.removeItem("userId");
      localStorage.removeItem("clientId");
      localStorage.removeItem("eventId");
      localStorage.removeItem("token");
      this.$router.push('/login');
    }
  }
});

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_js__ = __webpack_require__(13);








var jwt = __webpack_require__(137);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Login",
  data: function data(router) {
    return {
      email: "",
      password: "",
      token: "",
      showPleaseWait: false,
      showMessage: false,
      displayMsg: ""
    };
  },

  computed: {
    isValidEmail: function isValidEmail() {
      return (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)
      );
    }
  },
  mounted: function mounted() {

    console.log("Login Page Mounted");
    console.log(__WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].url);
  },

  methods: {
    login: function login() {
      var _this = this;

      this.showPleaseWait = true;

      console.log("Login");
      console.log(this.email);
      console.log(this.password);

      var payload = {
        confEmail: this.email,
        confPassword: this.password
      };

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].url + "/api/conf-login", payload).then(function (response) {
        console.log("Conf Login API Response");

        console.log(response);

        console.log("clientId: " + response.data.clientId);
        console.log("eventId: " + response.data._id);

        localStorage.setItem('clientId', response.data.clientId);
        localStorage.setItem('eventId', response.data._id);

        __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].clientId = response.data.clientId;
        __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].eventId = response.data._id;

        console.log("Hello...");

        _this.$router.push("/");
      }).catch(function (e) {
        console.log("Error :" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));

        console.log("Please Try Again.");

        _this.showPleaseWait = false;
        _this.showMessage = true;
        _this.displayMsg = "Incorrect email & password combination. Please try again...";
      });
    }
  }
});

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SidebarMenu__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',
  props: ['displayName', 'pictureUrl'],
  components: { SidebarMenu: __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default.a },
  mounted: function mounted() {
    window.jQuery('[data-toggle="hideseek"]').off().hideseek();
  },
  methods: {}
});

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_js__ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SidebarMenu',
  data: function data() {
    return {
      Mobile: "",
      Token: "",
      AccessRights: {
        Dashboard: true,
        Users: true,
        Events: true,
        Checkpoints: true,
        MyVisitors: false,
        AllVisitors: false
      }
    };
  },
  mounted: function mounted() {},
  methods: {}
});

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_js__ = __webpack_require__(13);








var jwt = __webpack_require__(137);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Login",
  data: function data(router) {
    return {
      email: "",
      password: "",
      token: "",
      showPleaseWait: false,
      showMessage: false,
      displayMsg: ""
    };
  },

  computed: {
    isValidEmail: function isValidEmail() {
      return (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)
      );
    }
  },
  mounted: function mounted() {

    console.log("Login Page Mounted");
    console.log(__WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].url);
  },

  methods: {
    login: function login() {
      var _this = this;

      this.showPleaseWait = true;

      console.log("Login");
      console.log(this.email);
      console.log(this.password);

      var payload = {
        confEmail: this.email,
        confPassword: this.password
      };

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].url + "/api/conf-login", payload).then(function (response) {
        console.log("Conf Login API Response");

        console.log(response);

        console.log("clientId: " + response.data.clientId);
        console.log("eventId: " + response.data._id);

        localStorage.setItem('clientId', response.data.clientId);
        localStorage.setItem('eventId', response.data._id);

        __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].clientId = response.data.clientId;
        __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].eventId = response.data._id;

        console.log("Hello...");

        _this.$router.push("/");
      }).catch(function (e) {
        console.log("Error :" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));

        console.log("Please Try Again.");

        _this.showPleaseWait = false;
        _this.showMessage = true;
        _this.displayMsg = "Incorrect email & password combination. Please try again...";
      });
    }
  }
});

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);










__webpack_require__(22);
__webpack_require__(65);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      showLoading: true,
      showTable: false,
      List: []
    };
  },
  mounted: function mounted() {

    console.log("Scanner History Component Loaded...");
    console.log("URL: " + __WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].url);
    console.log("clientId: " + __WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].clientId);
    console.log("eventId: " + __WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].eventId);

    this.getAll();
  },

  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    getAll: function getAll() {
      var _this = this;

      console.log("Get Access Logs");

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].url + '/api/accesslogs-eventId/' + __WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].eventId).then(function (response) {
        console.log("Get All AccessLogs API Response");

        console.log(response);

        _this.List = response.data;

        console.log("Access Logs: " + _this.List.length);
        _this.showLoading = false;
        _this.showTable = true;

        setTimeout(function () {
          _this.DisplayTable();
        }, 500);
      }).catch(function (e) {
        alert(e);
        console.log("Error :" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));
      });
    },
    DisplayTable: function DisplayTable() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$nextTick(function () {

          var table = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#example').DataTable({
            fixedColumns: true,
            autoWidth: true,
            buttons: [{
              extend: 'csvHtml5',
              text: 'Export To Excel',
              title: 'AccessLogs'
            }]
          });

          _this2.isLoading = false;
        });
      }, 100);
    }
  }
});

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {

      console.log("3 second time out");

      var ctx = _this.$refs.chart.getContext('2d');
      _this.chart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, {
        type: 'bar',
        data: _this.chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              ticks: {
                fontSize: 12,
                fontColor: '#333',
                fontStyle: 'bold'
              }
            }],
            yAxes: [{
              ticks: {
                fontSize: 12,
                fontColor: '#333',
                fontStyle: 'bold',
                beginAtZero: true
              }
            }]
          },
          legend: {
            display: false
          }
        }
      });
    }, 3000);
  },

  watch: {
    chartData: function chartData() {
      console.log("Watch chartdata");
      this.updateChart();
    }
  },
  methods: {
    renderChart: function renderChart() {
      if (!this.$refs.chart) {
        return;
      }

      if (this.chart) {
        this.chart.destroy();
      }

      var ctx = this.$refs.chart.getContext('2d');
      this.chart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, {
        type: 'bar',
        data: this.chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false
        }
      });
    },
    updateChart: function updateChart() {
      if (this.chart) {
        this.chart.data = this.chartData;
        this.chart.update();
      } else {
        this.renderChart();
      }
    }
  },
  destroyed: function destroyed() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);










__webpack_require__(22);
__webpack_require__(65);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      List: [],
      Checkpoints: [],
      AccessRights: __WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].AccessRights,
      eventId: __WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].eventId,
      clientId: __WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].clientId,
      url: __WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].url,
      table: '',
      ShowTable: false,
      ShowLoading: true,
      name: '',
      mobile: '',
      password: '',
      checkpoint: '',
      scannerUrl: '',
      EditInfo: {
        name: '',
        mobile: '',
        password: '',
        checkPoint: ''
      }
    };
  },
  mounted: function mounted() {

    console.log("Checkpoints Component Loaded...");
    console.log("url: " + __WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].url);
    console.log("clientId: " + __WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].clientId);
    console.log("eventId: " + __WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].eventId);
    console.log("Token: " + __WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].token);

    this.GetCheckpoints();
  },

  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    GetCheckpoints: function GetCheckpoints() {
      var _this = this;

      console.log("Get Checkpoints");

      console.log(__WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].eventId);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].url + '/api/checkpoints-eventId/' + __WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].eventId).then(function (response) {
        console.log("Get All Checkpoints API Response");

        console.log(response);

        _this.Checkpoints = response.data;
        _this.List = response.data;
        console.log(_this.Checkpoints);
        console.log("Total Checkpoints: " + _this.Checkpoints.length);
        _this.ShowLoading = false;
        _this.ShowTable = true;

        _this.scannerUrl = _this.Checkpoints[0].eventId.customFields.scannerUrl;
        console.log("Scanner URL: " + _this.scannerUrl);

        setTimeout(function () {
          _this.DisplayTable();
        }, 500);
      }).catch(function (e) {
        alert(e);
        console.log("Error :" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));
      });
    },
    Add: function Add() {

      var payload = {
        name: this.name,
        mobile: this.mobile,
        password: this.password,
        checkPoint: this.checkpoint,
        eventId: __WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].eventId,
        clientId: __WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].clientId
      };

      console.log('Add Checkpoint Info:', payload);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].url + '/api/add-checkpoint', payload).then(function (res) {
        console.log(res);
        location.reload();
      }).catch(function (e) {
        console.log("error is : " + e);
        swal("Oops!", "Something went wrong. Please contact support!", "error");
      });
    },
    EditModal: function EditModal(info) {

      this.EditInfo = {
        checkpointId: info._id,
        name: info.name,
        mobile: info.mobile,
        password: info.password,
        checkPoint: info.checkPoint
      };

      console.log("Info to be Edited: " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.EditInfo));
    },
    Edit: function Edit() {

      console.log("Payload: " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.EditInfo));

      console.log("Checkpoint ID: " + this.EditInfo.checkpointId);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].url + '/api/edit-checkpoint', this.EditInfo).then(function (res) {
        console.log(res);
        location.reload();
      }).catch(function (e) {
        console.log("error is : " + e);
        swal("Oops!", "Something went wrong. Please contact support!", "error");
      });
    },
    Delete: function Delete(c) {

      var checkpointId = c._id;

      console.log("CheckpointID: " + checkpointId);

      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
        title: 'Are you sure?',
        text: "You won't be able to undo this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        closeOnConfirm: false,
        closeOnCancel: false
      }).then(function (result) {
        if (result.value) {

          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_4__main_js__["globalStore"].url + '/api/delete-checkpoint', { checkpointId: checkpointId }).then(function (res) {
            console.log(res);
            location.reload();
          }).catch(function (e) {
            console.log("error" + e);
            swal("Oops!", "Something went wrong. Please contact support!", "error");
          });
        }
      });
    },
    DisplayTable: function DisplayTable() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$nextTick(function () {

          var table = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#example').DataTable({
            fixedColumns: true,
            autoWidth: true,
            buttons: [{
              extend: 'csvHtml5',
              text: 'Export To Excel',
              title: _this2.fromDate + ' To ' + _this2.toDate + ' Feedbacks'
            }]
          });

          _this2.isLoading = false;
        });
      }, 100);
    }
  }
});

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_auto_complete__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_auto_complete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_auto_complete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_PieChart_vue__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_PieChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_views_PieChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_BarChart_vue__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_BarChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_views_BarChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_InvitationsChart_vue__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_InvitationsChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_views_InvitationsChart_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Autocomplete: __WEBPACK_IMPORTED_MODULE_4_vuejs_auto_complete___default.a,
    InvitationsChart: __WEBPACK_IMPORTED_MODULE_8__components_views_InvitationsChart_vue___default.a,
    PieChart: __WEBPACK_IMPORTED_MODULE_6__components_views_PieChart_vue___default.a,
    BarChart: __WEBPACK_IMPORTED_MODULE_7__components_views_BarChart_vue___default.a
  },
  data: function data() {
    return {
      total: 0,
      analytics: []
    };
  },
  mounted: function mounted() {

    console.log("Dashboard Component Loaded...");

    console.log("url: " + __WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url);
    console.log("clientId: " + __WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].clientId);
    console.log("employeeId: " + __WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].employeeId);

    this.getAnalytics();
    this.GetRegistrations();
  },

  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    getAnalytics: function getAnalytics() {
      var _this = this;

      console.log("Get Analytics...");

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url + '/api/conf-analytics/' + __WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].eventId).then(function (response) {
        console.log("Get Conf Analytics API Response");

        console.log(response);

        _this.analytics = response.data;

        console.log("Analytics: " + _this.analytics.length);
      });
    },
    GetRegistrations: function GetRegistrations() {
      var _this2 = this;

      console.log("Get All Registrations");

      var config = {
        headers: {
          Authorization: __WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].token
        }
      };

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url + '/api/get-all-rsvp-event/' + __WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].eventId).then(function (response) {
        console.log("Get All Registrations API Response");

        console.log(response);

        _this2.total = response.data.length;
      }).catch(function (e) {
        alert(e);
        console.log("Error :" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));
      });
    }
  }
});

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_auto_complete__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_auto_complete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_auto_complete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main_js__ = __webpack_require__(13);









__webpack_require__(22);
__webpack_require__(65);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Autocomplete: __WEBPACK_IMPORTED_MODULE_4_vuejs_auto_complete___default.a
  },
  data: function data() {
    return {
      rsvpId: "",
      idCardInfo: {},
      FormInfo: {},
      adminInfo: {},
      clientId: __WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].clientId,
      employeeId: localStorage.getItem('employeeId'),
      url: __WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url,
      token: localStorage.getItem('token'),
      table: '',
      List: [],
      showLoading: true,
      showPleaseWait: false,
      showTable: false
    };
  },
  created: function created() {

    console.log("Created");

    this.rsvpId = this.$route.query.rsvpId;
    console.log(this.rsvpId);
  },
  mounted: function mounted() {

    console.log("Mounted");
    this.getRsvpInfo();
    this.getParams();
  },

  methods: {
    getRsvpInfo: function getRsvpInfo() {
      var _this = this;

      console.log("Get RSVP Info for: " + this.rsvpId);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url + '/api/get-one-rsvp/' + this.rsvpId).then(function (response) {
        console.log("Get rsvpInfo API Response");

        console.log(response);

        _this.idCardInfo = response.data[0];

        _this.showLoading = false;
        _this.showTable = true;
      }).catch(function (e) {
        alert(e);
        console.log("Error :" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));
      });
    },
    save: function save() {
      var _this2 = this;

      this.alertMessage = "Please wait...";
      this.showPleaseWait = true;

      console.log("Save Clicked");
      console.log(this.idCardInfo.customFields.rsvpInfo);

      var payload = {};
      payload.rsvpId = this.idCardInfo._id;
      payload.rsvpInfo = this.idCardInfo.customFields.rsvpInfo;

      console.log("rsvpId: " + payload.rsvpId);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url + '/api/update-rsvpinfo', payload).then(function (response) {
        console.log("Update rsvpInfo API Response");

        console.log(response);

        _this2.getRsvpInfo();

        _this2.alertMessage = "Saved Successfully.";

        setTimeout(function () {

          _this2.showPleaseWait = false;
        }, 3000);
      }).catch(function (e) {
        alert(e);
        console.log("Error :" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));
      });
    },
    generateIdCard: function generateIdCard() {
      var _this3 = this;

      this.alertMessage = "Generating ID Card. This will take a while. Please wait...";
      this.showPleaseWait = true;

      console.log("Generate ID Card Clicked.");
      console.log(this.idCardInfo.customFields.rsvpInfo);

      var payload = {};
      payload.rsvpId = this.idCardInfo._id;
      payload.imgUrl = this.idCardInfo.customFields.idCardInfo.imageUrl;
      payload.name = this.idCardInfo.customFields.rsvpInfo.name;
      payload.uid = this.idCardInfo.customFields.rsvpInfo.uid;
      payload.mobile = this.idCardInfo.customFields.rsvpInfo.mobile;
      payload.email = this.idCardInfo.customFields.rsvpInfo.email;
      payload.dob = this.idCardInfo.customFields.rsvpInfo.dob;

      console.log("rsvpId: " + payload.rsvpId);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url + '/api/generate-idcard-cyl', payload).then(function (response) {
        console.log("Update rsvpInfo API Response");

        console.log(response);

        _this3.getRsvpInfo();

        _this3.alertMessage = "ID Card Generated Successfully.";

        setTimeout(function () {

          _this3.showPleaseWait = false;
        }, 3000);
      }).catch(function (e) {
        alert(e);
        console.log("Error :" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));
      });
    },
    sendIDCardPrompt: function sendIDCardPrompt() {
      var _this4 = this;

      var Swal = __webpack_require__(18);

      console.log(this.idCardInfo.customFields.rsvpInfo.mobile);

      Swal.fire({
        title: 'Enter Mobile to Send ID Card',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        inputValue: this.idCardInfo.customFields.rsvpInfo.mobile,
        showCancelButton: true,
        confirmButtonText: 'Send Whatsapp',
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(mobile) {
          console.log("User input:", mobile);

          console.log("New Mobile: " + mobile);

          var Swal = __webpack_require__(18);

          _this4.sendWhatsappIDCard(mobile);
        },
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        if (result.isConfirmed) {}
      });
    },
    sendWhatsappIDCard: function sendWhatsappIDCard(mobile) {

      console.log("Send ID Card via Whatsapp");

      console.log("New Mobile: " + mobile);

      var url = 'https://live-server-1238.wati.io/api/v1/sendTemplateMessage?whatsappNumber=' + mobile;
      var options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI0YTIwNmQ0OS1lZTE1LTRlOGEtOGE4My02N2MxZmVmYWFiMWMiLCJ1bmlxdWVfbmFtZSI6Im9ubGluZUBzbmVod29ybGQuY29tIiwibmFtZWlkIjoib25saW5lQHNuZWh3b3JsZC5jb20iLCJlbWFpbCI6Im9ubGluZUBzbmVod29ybGQuY29tIiwiYXV0aF90aW1lIjoiMDYvMDYvMjAyNCAwNTo1NjoyOSIsImRiX25hbWUiOiJtdC1wcm9kLVRlbmFudHMiLCJ0ZW5hbnRfaWQiOiIxMjM4IiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjoiQURNSU5JU1RSQVRPUiIsImV4cCI6MjUzNDAyMzAwODAwLCJpc3MiOiJDbGFyZV9BSSIsImF1ZCI6IkNsYXJlX0FJIn0.h5NOZfrzYxhmcUbETn6Wj3xem2oy674-MvQz46mBEOE'
        },
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          broadcast_name: 'cyl_send_idcard_admin_panel',
          parameters: [{ name: 'name', value: this.idCardInfo.customFields.rsvpInfo.name }, { name: 'idcard_url', value: this.idCardInfo.customFields.idCardInfo.idCardUrl }],
          template_name: 'cyl_id_card'
        })
      };

      __WEBPACK_IMPORTED_MODULE_3_axios___default()(url, options).then(function (response) {
        return response.data;
      }).then(function (data) {
        console.log("-- Data Processed --");

        Swal.fire({
          title: 'Success!',
          text: 'Whatsapp has been sent successfully.',
          icon: 'success',
          confirmButtonText: 'Ok'
        });
      }).catch(function (error) {
        console.log("------- ERROR -------");
        console.error('error:' + error);
        console.log("--- xxx ---");

        var Swal = __webpack_require__(18);
        Swal.fire({
          title: 'Sorry!',

          html: 'Something went wrong. Please try again.',
          type: 'error',
          showConfirmButton: false
        });
      });
    },
    getParams: function getParams() {

      console.log("Get All Params");

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url + '/api/get-all-params').then(function (response) {
        console.log("Get All Params API Response");

        console.log(response);

        console.log("Available UID: " + response.data[0].customFields.cyl_counter);
      }).catch(function (e) {
        alert(e);
        console.log("Error :" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));
      });
    }
  }
});

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    invitations: Object
  },
  mounted: function mounted() {
    this.renderChart();
  },

  methods: {
    renderChart: function renderChart() {
      var chartData = {
        labels: ['Total', 'Not Arrived', 'Gold', 'Silver', 'Platinum'],
        datasets: [{
          label: 'Invitations',
          backgroundColor: 'rgba(54, 162, 235, 0.2)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(54, 162, 235, 0.4)',
          hoverBorderColor: 'rgba(54, 162, 235, 1)',
          data: [this.invitations.total, this.invitations.notArrived, this.invitations.gold, this.invitations.silver, this.invitations.platinum]
        }]
      };

      var chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function label(tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';
              if (label) {
                label += ': ';
              }
              label += tooltipItem.yLabel;
              return label;
            }
          }
        },

        legend: {
          display: true,
          labels: {
            fontSize: 14,
            fontColor: 'black'
          }
        }
      };

      var ctx = this.$refs.chart.getContext('2d');
      new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, {
        type: 'bar',
        data: chartData,
        options: chartOptions
      });
    }
  }
});

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    this.renderChart();
  },

  methods: {
    renderChart: function renderChart() {
      var ctx = this.$refs.canvas.getContext('2d');
      new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, {
        type: 'pie',
        data: this.chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false
        }
      });
    }
  }
});

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_auto_complete__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_auto_complete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_auto_complete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_datatables_net_buttons_js_buttons_html5_js__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_datatables_net_buttons_js_buttons_html5_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_datatables_net_buttons_js_buttons_html5_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_datatables_net_buttons_js_buttons_print_js__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_datatables_net_buttons_js_buttons_print_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_datatables_net_buttons_js_buttons_print_js__);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Autocomplete: __WEBPACK_IMPORTED_MODULE_4_vuejs_auto_complete___default.a
  },
  data: function data() {
    return {
      alertMessage: "Please wait...",
      showPleaseWait: false,
      FormInfo: {},
      clientId: __WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].clientId,
      url: __WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url,
      table: '',
      List: [],
      Checkpoints: [],
      showLoading: true,
      showLoading2: false,
      showTable: false,
      Total: 0,
      Arrived: 0,
      NotArrived: 0,
      LinkOpened: 0,
      eventId: __WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].eventId,
      eventInfo: {},
      rsvpInfo: {},
      tableHeader: {},
      formInfo: {
        name: "",
        mobile: "",
        email: "",
        regNo: " - ",
        regType: " - ",
        packageName: " - ",
        personType: " - "
      },
      analytics: [],
      stats: [],
      idCardStats: [],
      Count: {
        Total: 0,
        Arrived: 0,
        NotArrived: 0
      },
      editId: "",
      editInfo: {}
    };
  },
  mounted: function mounted() {

    this.showLoading = true;

    console.log("RSVP Component Loaded...");

    console.log("eventId: " + this.eventId);
    console.log("clientId: " + this.clientId);
    console.log("url: " + __WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url);

    if (localStorage.getItem('clientId') && localStorage.getItem('eventId')) {
      console.log("Already Logged In");
      console.log("eventId: " + localStorage.getItem('eventId'));
      console.log("clientId: " + localStorage.getItem('clientId'));

      this.GetEventInfo();
    } else {
      console.log("Not Logged In");
    }
  },

  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    tempFunc: function tempFunc() {
      var _this = this;

      console.log("Temp Function");

      setTimeout(function () {

        setInterval(function () {
          _this.Arrived++;
          _this.NotArrived--;
        }, 1200);
      }, 10000);
    },
    sendWhatsappPrompt: function sendWhatsappPrompt(info) {
      var _this2 = this;

      console.log(info.mobile);

      Swal.fire({
        title: 'Enter Mobile',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        inputValue: info.mobile,
        showCancelButton: true,
        confirmButtonText: 'Send Whatsapp',
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(mobile) {
          console.log("User input:", mobile);

          info.mobile = mobile;

          console.log("New Mobile: " + info.mobile);

          _this2.sendWhatsapp(info);
        },
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        if (result.isConfirmed) {}
      });
    },
    sendIDCardPrompt: function sendIDCardPrompt(info) {
      var _this3 = this;

      var Swal = __webpack_require__(18);

      console.log(info.mobile);

      Swal.fire({
        title: 'Enter Mobile to Send ID Card',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        inputValue: info.mobile,
        showCancelButton: true,
        confirmButtonText: 'Send Whatsapp',
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(mobile) {
          console.log("User input:", mobile);

          info.mobile = mobile;

          console.log("New Mobile: " + info.mobile);

          var Swal = __webpack_require__(18);

          _this3.sendWhatsappIDCard(info);
        },
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        if (result.isConfirmed) {}
      });
    },
    getAnalytics_dep: function getAnalytics_dep() {
      var _this4 = this;

      console.log("Get Analytics...");

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url + '/api/conf-analytics/' + __WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].eventId).then(function (response) {
        console.log("Get Conf Analytics API Response");

        console.log(response);

        _this4.analytics = response.data;

        console.log("Analytics: " + _this4.analytics.length);
      });
    },
    getAnalytics: function getAnalytics() {
      var _this5 = this;

      console.log("Get Analytics...");

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url + '/api/cyl-stats').then(function (response) {
        console.log("Get cyl-stats Info API Response");

        console.log(response);

        _this5.stats = response.data;
        console.log("Length: " + _this5.stats.length);

        _this5.Total = 0;
        _this5.Arrived = 0;
        _this5.NotArrived = 0;

        _this5.stats.map(function (val) {
          console.log(val._id + " " + val.arrived + " " + val.notArrived);
          _this5.Total = _this5.Total + val.arrived + val.notArrived;
          _this5.Arrived = _this5.Arrived + val.arrived;
          _this5.NotArrived = _this5.NotArrived + val.notArrived;
        });
      }).catch(function (e) {

        console.log("Error :" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));

        _this5.showStatsLoading = false;
        _this5.showStats = true;
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url + '/api/cyl-stats-idcard').then(function (response) {
        console.log("Get cyl-stats-idcard Info API Response");

        console.log(response);
        _this5.idCardStats = response.data;
        console.log("Length: " + _this5.idCardStats.length);

        _this5.stats.map(function (val) {
          console.log(val._id + " " + val.saved + " " + val.pending);
        });
      }).catch(function (e) {

        console.log("Error :" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));

        _this5.showStatsLoading = false;
        _this5.showStatsIDCard = true;
      });
    },
    GetEventInfo: function GetEventInfo() {
      var _this6 = this;

      console.log("Get Event Info");
      console.log("EventId: " + this.eventId);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url + '/api/get-eventInfo/' + this.eventId).then(function (response) {
        console.log("Get Event Info API Response");

        console.log(response);
        _this6.eventInfo = response.data[0];

        __WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].eventInfo = response.data[0];

        console.log("Event Name: " + _this6.eventInfo.eventName);

        _this6.GetRegistrations();
        _this6.GetCheckPoints();
        _this6.getAnalytics();
      }).catch(function (e) {
        alert(e);
        console.log("Error :" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));
      });
    },
    GetCheckPoints: function GetCheckPoints() {
      var _this7 = this;

      console.log("Get Checkpoints");
      console.log("EventId: " + this.eventId);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url + '/checkPoints/' + __WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].clientId).then(function (response) {
        console.log("Get All Checkpoints API Response");

        console.log(response);

        _this7.List = response.data;
        console.log(_this7.List);
        console.log("Total Checkpoints for client: " + _this7.List.length);

        _this7.List.map(function (info) {

          if (info.eventId._id == _this7.eventId) {
            _this7.Checkpoints.push(info);
          }
        });

        setTimeout(function () {
          console.log("Total Checkpoints for Event: " + _this7.Checkpoints.length);
        }, 1000);
      }).catch(function (e) {
        console.log("Error :" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));
      });
    },
    GetRegistrations: function GetRegistrations() {
      var _this8 = this;

      console.log("Get All Registrations");

      var config = {
        headers: {
          Authorization: __WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].token
        }
      };

      console.log("EventId: " + this.eventId);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url + '/api/get-all-rsvp-event2/' + this.eventId).then(function (response) {
        console.log("Get All Registrations API Response");

        console.log(response);

        _this8.List = response.data;

        _this8.tableHeader = _this8.eventInfo;

        console.log(_this8.List);
        _this8.Total = _this8.List.length;
        console.log("Total Registrations: " + _this8.List.length);

        _this8.showLoading = false;
        _this8.showTable = true;

        setTimeout(function () {
          _this8.DisplayTable();
        }, 500);
      }).catch(function (e) {
        console.log("Error :" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));
      });
    },
    CalculateDashboard: function CalculateDashboard() {
      var _this9 = this;

      this.Arrived = 0;
      this.NotArrived = 0;
      this.LinkOpened = 0;

      this.List.map(function (info) {

        console.log(info.status);

        if (info.linkOpened == true) {
          _this9.LinkOpened++;
        }

        if (info.status == 'arrived') {
          _this9.Arrived++;
        } else if (info.status == '') {
          _this9.NotArrived++;
        }
      });
    },
    Add: function Add() {
      var _this10 = this;

      console.log("Add Walk-In");

      this.showLoading2 = true;

      console.log(this.formInfo);

      var payload = {
        eventId: this.eventId,
        clientId: this.clientId,
        name: this.formInfo.name,
        email: this.formInfo.email,
        mobile: this.formInfo.mobile,
        status: "",
        customFields: {
          batch: "WalkIn",
          rsvpInfo: this.formInfo
        },
        autoEmail: this.eventInfo.customFields.autoEmail,
        fromEmail: "hello@visity.io",
        qrcodeUrl: "https://qrcode.visity.io"
      };

      console.log("Payload: " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload));

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url + '/api/add-rsvp-v2', payload).then(function (res) {
        console.log(res);

        var url = res.data.data.eTicketUrl;
        console.log("QR Code URL: " + url);

        _this10.sendWhatsapp(url);
      }).catch(function (e) {
        console.log("error is : " + e);
        swal("Oops!", "Something went wrong. Please contact support!", "error");
      });
    },
    sendWhatsapp: function sendWhatsapp(info) {

      console.log("Send Whatsapp");

      console.log(info.customFields.rsvpInfo.name);
      console.log(info.mobile);
      console.log(info.customFields.rsvpInfo.category);

      var url = 'https://live-server-1238.wati.io/api/v1/sendTemplateMessage?whatsappNumber=' + info.mobile;
      var options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI0YTIwNmQ0OS1lZTE1LTRlOGEtOGE4My02N2MxZmVmYWFiMWMiLCJ1bmlxdWVfbmFtZSI6Im9ubGluZUBzbmVod29ybGQuY29tIiwibmFtZWlkIjoib25saW5lQHNuZWh3b3JsZC5jb20iLCJlbWFpbCI6Im9ubGluZUBzbmVod29ybGQuY29tIiwiYXV0aF90aW1lIjoiMDYvMDYvMjAyNCAwNTo1NjoyOSIsImRiX25hbWUiOiJtdC1wcm9kLVRlbmFudHMiLCJ0ZW5hbnRfaWQiOiIxMjM4IiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjoiQURNSU5JU1RSQVRPUiIsImV4cCI6MjUzNDAyMzAwODAwLCJpc3MiOiJDbGFyZV9BSSIsImF1ZCI6IkNsYXJlX0FJIn0.h5NOZfrzYxhmcUbETn6Wj3xem2oy674-MvQz46mBEOE'
        },
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          broadcast_name: 'qr_cyl_one_admin_panel',
          parameters: [{ name: 'name', value: info.customFields.rsvpInfo.name }, { name: 'category_name', value: info.customFields.rsvpInfo.category }, { name: 'QRCode_URL', value: info.eTicketUrl }],
          template_name: 'cyl_qr_ticket_16thto18thaug24'
        })
      };

      __WEBPACK_IMPORTED_MODULE_3_axios___default()(url, options).then(function (response) {
        console.log(info.name + " " + info.mobile + " " + info.category);
        return response.data;
      }).then(function (data) {
        console.log("-- Data Processed --");

        Swal.fire({
          title: 'Success!',
          text: 'Whatsapp has been sent successfully.',
          icon: 'success',
          confirmButtonText: 'Ok'
        });
      }).catch(function (error) {
        console.log("------- ERROR -------");
        console.log(info.name + " " + info.mobile + " " + info.category);
        console.error('error:' + error);
        console.log("--- xxx ---");

        var Swal = __webpack_require__(18);
        Swal.fire({
          title: 'Sorry!',

          html: 'Something went wrong. Please try again.',
          type: 'error',
          showConfirmButton: false
        });
      });
    },
    sendWhatsappIDCard: function sendWhatsappIDCard(info) {

      console.log("Send ID Card via Whatsapp");

      console.log(info.customFields.rsvpInfo.name);
      console.log(info.mobile);
      console.log(info._id);

      var url = 'https://live-server-1238.wati.io/api/v1/sendTemplateMessage?whatsappNumber=' + info.mobile;
      var options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI0YTIwNmQ0OS1lZTE1LTRlOGEtOGE4My02N2MxZmVmYWFiMWMiLCJ1bmlxdWVfbmFtZSI6Im9ubGluZUBzbmVod29ybGQuY29tIiwibmFtZWlkIjoib25saW5lQHNuZWh3b3JsZC5jb20iLCJlbWFpbCI6Im9ubGluZUBzbmVod29ybGQuY29tIiwiYXV0aF90aW1lIjoiMDYvMDYvMjAyNCAwNTo1NjoyOSIsImRiX25hbWUiOiJtdC1wcm9kLVRlbmFudHMiLCJ0ZW5hbnRfaWQiOiIxMjM4IiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjoiQURNSU5JU1RSQVRPUiIsImV4cCI6MjUzNDAyMzAwODAwLCJpc3MiOiJDbGFyZV9BSSIsImF1ZCI6IkNsYXJlX0FJIn0.h5NOZfrzYxhmcUbETn6Wj3xem2oy674-MvQz46mBEOE'
        },
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          broadcast_name: 'cyl_idcard_admin_panel',
          parameters: [{ name: 'name', value: info.name }, { name: 'var', value: info._id }],
          template_name: 'generateid_visity'
        })
      };

      __WEBPACK_IMPORTED_MODULE_3_axios___default()(url, options).then(function (response) {
        console.log(info.name + " " + info.mobile);
        return response.data;
      }).then(function (data) {
        console.log("-- Data Processed --");

        Swal.fire({
          title: 'Success!',
          text: 'Whatsapp has been sent successfully.',
          icon: 'success',
          confirmButtonText: 'Ok'
        });
      }).catch(function (error) {
        console.log("------- ERROR -------");
        console.log(info.name + " " + info.mobile + " " + info.category);
        console.error('error:' + error);
        console.log("--- xxx ---");

        var Swal = __webpack_require__(18);
        Swal.fire({
          title: 'Sorry!',

          html: 'Something went wrong. Please try again.',
          type: 'error',
          showConfirmButton: false
        });
      });
    },
    editIDCard: function editIDCard(info) {

      console.log("Edit ID Card");

      console.log(info._id);

      var rsvpId = info._id;

      var queryParams = { rsvpId: rsvpId };

      var url = this.$router.resolve({
        path: 'edit-id-card',
        query: queryParams
      }).href;

      window.open(url, '_blank');
    },
    editSetup: function editSetup(info) {

      console.log("Edit Setup");

      console.log(info);

      this.editId = info._id;
      this.editInfo = info.customFields.rsvpInfo;

      console.log("id: " + this.editId);
      console.log("Info: " + this.editInfo);
    },
    editSave: function editSave() {
      var _this11 = this;

      this.alertMessage = "Please wait...";
      this.showPleaseWait = true;

      console.log("Save");

      console.log(this.editInfo);
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.editInfo));

      var payload = {
        rsvpId: this.editId,
        rsvpInfo: this.editInfo
      };

      console.log("Payload: " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload));
      console.log("Payload: " + payload);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_5__main_js__["globalStore"].url + '/api/update-rsvpinfo', payload).then(function (response) {
        console.log("Update rsvpInfo API Response");

        console.log(response);

        _this11.alertMessage = "Saved Successfully.";

        setTimeout(function () {

          _this11.showPleaseWait = false;
        }, 3000);

        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#example').DataTable().destroy();

        _this11.DisplayTable();
      }).catch(function (e) {
        alert(e);
        console.log("Error :" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));
      });
    },
    DisplayTable: function DisplayTable() {
      var _this12 = this;

      setTimeout(function () {
        _this12.$nextTick(function () {

          var table = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#example').DataTable({
            autoWidth: true,
            sDom: 'lriftpB',
            buttons: [{
              extend: 'csvHtml5',
              text: 'Export as .CSV',
              title: _this12.eventInfo.eventName
            }]
          });

          _this12.isLoading = false;
        });
      }, 1000);
    }
  }
});

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  token: null,
  userInfo: {
    messages: [{ 1: 'test', 2: 'test' }],
    notifications: [],
    tasks: []
  }
});

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 413:
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 418:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 429:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[13]);


// WEBPACK FOOTER //
// static/js/app.0f113f0c7b16af9cb3b8.js